import { render, staticRenderFns } from "./LFormItem.vue?vue&type=template&id=12b05f6e"
import script from "./LFormItem.vue?vue&type=script&lang=js"
export * from "./LFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports